import { Ticket, TicketId, TicketVariant } from '../../../models/tickets';

const _getTotalCostWithShippingFee = (
    totalCost: { value: number },
    totalCostWithoutShipping: { value: number },
    selectedQuantity: number,
) =>
    totalCost && totalCostWithoutShipping && selectedQuantity > 0
        ? totalCost.value +
          totalCostWithoutShipping.value * (selectedQuantity - 1)
        : 0;

const _getTotalCostWithoutShippingFee = (
    totalCost: { value: number },
    selectedQuantity: number,
) => (totalCost?.value ?? 0) * (selectedQuantity ?? 0);

export const getTotalCost = (
    tickets: Record<TicketId, Ticket> | TicketVariant[] | Ticket[],
) =>
    tickets
        ? Object.values(tickets).reduce((total, ticket) => {
              const {
                  displayShippingFee,
                  selectedQuantity,
                  totalCost,
                  totalCostWithoutShipping,
                  variants,
              } = ticket;

              const sum = displayShippingFee?.value
                  ? _getTotalCostWithShippingFee(
                        totalCost,
                        totalCostWithoutShipping,
                        selectedQuantity,
                    )
                  : _getTotalCostWithoutShippingFee(
                        totalCost,
                        selectedQuantity,
                    );

              const variantsCost: number = variants
                  ? getTotalCost(variants)
                  : 0;

              return total + sum + variantsCost;
          }, 0)
        : 0;
